<template>
    <div>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="4" search :data="taskMaterials">

            <div slot="header" v-if="canEdit">

                <vs-button color="primary" type="border" @click="activeNewMaterialPrompt = true">{{$t("Add")}}</vs-button>

            </div>

            <template slot="thead">
                <vs-th sort-key="user">{{$t("User")}}</vs-th>
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="unit">{{$t("Unit")}}</vs-th>
                <vs-th sort-key="quantity">{{$t("Quantity")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].user_id">
                            {{ users[data[index].user_id].name }}
                        </vs-td>

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].unit">
                            {{data[index].unit }}
                        </vs-td>

                        <vs-td :data="data[index].quantity">
                            {{ data[index].quantity }}
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>

        </vs-table>
        <div v-if="selected.id && this.$store.getters.userData.id === selected.user_id" class="p-3">

            <vs-divider></vs-divider>
            <h5 class="mb-4">{{$t("EditMaterial")}}</h5>
            <vs-row vs-w="12">
                <vs-col vs-w="9" vs-sm="12">
                    <vs-row vs-w="12" vs-justify="space-around">
                        <vs-col vs-w="3" vs-sm="12">
                            <p>{{$t("Name")}}</p>
                            <vs-input v-model="editName"></vs-input>
                        </vs-col>
                        <vs-col vs-w="3" vs-sm="12">
                            <p>{{$t("Unit")}}</p>
                            <vs-select class="selectExample" v-model="editUnit">
                                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:$t('Meter'), name:$t('Meter')}, {id:$t('Piece'), name:$t('Piece')}]" />
                            </vs-select>
                        </vs-col>
                        <vs-col vs-w="3" vs-sm="12">
                            <p>{{$t("Quantity")}}</p>
                            <vs-input v-model="editQuantity"></vs-input>
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col vs-w="3" vs-sm="12" class="mt-3">
                    <vs-row vs-w="12" vs-justify="space-around">
                        <vs-col vs-w="4">
                            <vs-button color="success" type="border" class="mt-6; mr-1" @click="editMaterial">{{$t("Change")}}</vs-button>
                        </vs-col>
                        <vs-col vs-w="4">
                            <vs-button color="danger" type="border" class="mt-6; ml-1" @click="removeMaterial">{{$t("Delete")}}</vs-button>
                        </vs-col>
                    </vs-row>
                </vs-col>




            </vs-row>

        </div>

        <vs-popup :title="$t('Add')" :active.sync="activeNewMaterialPrompt" style="z-index: 54000">
            <div>
                <p>{{$t("Name")}}</p>
                <vs-input v-model="addName"></vs-input>
                <p class="mt-6">{{$t("Unit")}}</p>
                <vs-select class="selectExample" v-model="addUnit">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:$t('Meter'), name:$t('Meter')}, {id:$t('Piece'), name:$t('Piece')}]" />
                </vs-select>
                <p class="mt-6">{{$t("Quantity")}}</p>
                <vs-input v-model="addQuantity"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addMaterial">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>



    </div>
</template>

<script>

    export default {
        props: {
            taskId: {
                type: Number,
                required: true
            },
            users: {
                type: Object,
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            },
        },
        data() {
            return {
                activeNewMaterialPrompt: false,
                editName: '',
                editUnit: '',
                editQuantity: '',
                addName: '',
                addUnit: this.$t('Piece'),
                addQuantity: '',
                selectedWorkTypeAdd: 0,
                selected: {},
                taskMaterials: [],
            }
        },
        methods: {
            updateMaterials() {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/material")
                    .then(function (response) {
                        thisIns.taskMaterials = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            handleSelected(tr) {
                const thisIns = this;
                this.$http.get('/api/v1/task/' + this.taskId + "/material/" + tr.id)
                    .then(function (response) {
                        thisIns.editName = response.data.name;
                        thisIns.editUnit = response.data.unit;
                        thisIns.editQuantity = response.data.quantity;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

            },
            editMaterial() {
                const thisIns = this;
                this.$http.put('/api/v1/task/' + this.taskId + "/material/" + this.selected.id, {
                    name: thisIns.editName,
                    unit: thisIns.editUnit,
                    quantity: Number(thisIns.editQuantity)
                }).then(function () {
                    thisIns.updateMaterials();
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeMaterial() {
                const thisIns = this;
                this.$http.delete('/api/v1/task/' + this.taskId + "/material/" + this.selected.id)
                .then(function () {
                    thisIns.updateMaterials();
                    thisIns.selected = {};
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addMaterial() {
                const thisIns = this;
                this.$http.post('/api/v1/task/' + this.taskId + "/material", {
                    name: thisIns.addName,
                    unit: thisIns.addUnit,
                    quantity: Number(thisIns.addQuantity),
                }).then(function () {
                    thisIns.updateMaterials();
                    thisIns.activeNewMaterialPrompt = false
                }).catch(function (error) {
                    thisIns.activeNewMaterialPrompt = false
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        watch:{
            taskId: function () {
                this.updateMaterials();
            }
        },
        created() {

            this.updateMaterials();

        }

    }
</script>
